export default {
  setBackupsArray(state, bk) {
    state.backupsArray = bk;
  }
}